import React from "react";
import { Pie } from "@ant-design/plots";

const DynamicPieChart = ({ data, angleField, colorField, title, isMaximized }) => {
  const config = {
    appendPadding: 10,
    data: data,
    angleField: angleField,
    colorField: colorField,
    radius: isMaximized ? 1 : 0.75,
    autoFit: true,
    height: isMaximized ? 500 : 200,
    // height: 140, 
    label: false,
    // label: {
    //   type: "spider",
    //   labelHeight: 28,
    //   content: "{name}\n{percentage}",
    // },
    interactions: [
      { type: "element-selected" },
      { type: "element-active" },
    ],
  };

  return (
    <div className="my-4" style={{ width: "100%", height: isMaximized ? "60%" : "90%" }}>
      {title && <h3 className="text-center mb-2">{title}</h3>}
      <Pie {...config} />
    </div>
  );
};

export default DynamicPieChart;
